module.exports = __webpack_public_path__ + "img/29.36773cfb.jpg";